var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quote-block"},[_c('p',{staticClass:"quote-block__statement"},[_vm._v(_vm._s(_vm.statement))]),(_vm.data.quotee)?_c('p',{staticClass:"quote-block__quotee"},[_vm._v(_vm._s(_vm.data.quotee))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }